import * as Sentry from '@sentry/angular-ivy';
import { environment } from '@environment';

// part of configuration below was taken from here https://docs.sentry.io/platforms/javascript/guides/angular/best-practices/micro-frontends/

const EXTRA_KEY = 'ROUTE_TO';
const ORG_ID = 'ORG_ID';
const transport = Sentry.makeMultiplexedTransport(Sentry.makeFetchTransport, (args) => {
	const event = args.getEvent();
	if (event && event.extra && EXTRA_KEY in event.extra && Array.isArray(event.extra[EXTRA_KEY])) {
		return event.extra[EXTRA_KEY] as Array<any>;
	}
	return [];
});

/**
 * The DSN tells the SDK where to send the events to.
 */
const SENTRY_DSN = 'https://e3b627bca2ff4fa086eb57506a614b84@o4504892770877440.ingest.us.sentry.io/4504892774547456';
Sentry.init({
	dsn: SENTRY_DSN,
	enabled: environment.production,
	debug: false,
	environment: environment.production ? 'production' : 'development',
	beforeSend(event) {
		if (event.user) {
			delete event.user.ip_address;
			delete event.user.email;
		}

		if (event?.exception?.values?.[0]?.stacktrace?.frames) {
			const frames = event.exception.values[0].stacktrace.frames;
			// Find the last frame with module metadata containing a DSN
			const routeTo = frames
				.filter((frame) => frame.module_metadata && frame.module_metadata.dsn)
				.map((v) => v.module_metadata)
				.slice(-1); // using top frame only - you may want to customize this according to your needs

			if (routeTo.length) {
				event.extra = {
					...event.extra,
					[EXTRA_KEY]: routeTo,
					[ORG_ID]: window.zestyHost?.currentOrganization?.org_id,
				};
			}
		}

		return event;
	},
	integrations: [Sentry.browserTracingIntegration(), Sentry.moduleMetadataIntegration()],
	transport,
	tracesSampleRate: 0.5,
});
